import React from 'react';

function InfoBlock (props) {
    return (
        <div className="home_infoBlocks BlockTemplate">00007878980000</div>
    )
}

export default InfoBlock;